import { Component, ElementRef, Input, OnDestroy, OnInit, Renderer2, ViewChild, ViewEncapsulation } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { CookieService } from 'ngx-cookie-service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { FuseMatchMediaService } from '@fuse/services/match-media.service';
import { FuseNavigationService } from '@fuse/components/navigation/navigation.service';
import { LeaveService } from '../../../leave/services/leave.service';
import { EmployeeService } from '../../../employee/services/employee.service';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { EmployeeStoreService } from 'app/modules/employee/services/employee-store.service';
import { HeaderService } from '../../services/header-service';
import { SharedService } from 'app/modules/common/services/shared-service';
import { MatSnackBar, MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { CreateNewEmployeeComponent } from 'app/modules/employee/components/create-new-employee/create-new-employee.component';
import { ConfirmDialogModel } from 'app/modules/common/components/confirmation-dialog/confirm-dialog-model';
import { ConfirmationDialogComponent } from 'app/modules/common/components/confirmation-dialog/confirmation-dialog.component';
import { DoctorBillingService } from '../../services/doctor-billing.service';
import { TransferActuacionesModalComponent } from './popups/transfer-actuaciones-modal/transfer-actuaciones-modal.component';
import { CerrarfacturacionModalComponent } from './popups/cerrarfacturacion-modal/cerrarfacturacion-modal.component';
import { DateAdapter } from '@angular/material/core';
import { FileExportService } from 'app/modules/selection-generic/services/file-export.service';
import { TaskEliminationPopupComponent } from './sending-menu/task-elimination-popup/task-elimination-popup.component';
import { DerivarMutuaComponent } from './popups/derivar-mutua/derivar-mutua.component';
import { TaskPopupComponent } from './sending-menu/task-popup/task-popup.component';
import { DischargesPopupComponent } from './sending-menu/discharges-popup/discharges-popup.component';
import { ReportsPopupComponent } from './sending-menu/reports-popup/reports-popup.component';
import { SendingService } from '../../services/sending.service';
import { OpenAddressRequestPopupComponent } from './sending-menu/open-address-request-popup/open-address-request-popup.component';
import { OpenStaffRequestPopupComponent } from './sending-menu/open-staff-request-popup/open-staff-request-popup.component';
import { OpenDischargeRequestPopupComponent } from './sending-menu/open-discharge-request-popup/open-discharge-request-popup.component';
import { SendCitationsComponent } from './sending-menu/send-citations/send-citations.component';
import { DataCancelComponent } from './popups/data-cancel/data-cancel.component';
import Utils from 'app/Utils';

@Component({
    selector: 'fuse-shortcuts',
    templateUrl: './shortcuts.component.html',
    styleUrls: ['./shortcuts.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class FuseShortcutsComponent implements OnInit, OnDestroy {

    public allDoctors = [];
    public allAdministrativeUsers = [];

    shortcutItems: any[];
    navigationItems: any[];
    filteredNavigationItems: any[];
    searching: boolean;
    mobileShortcutsPanelActive: boolean;
    options: any[] = [];
    @Input()
    navigation: any;
    showHomeButton = false;

    @ViewChild('searchInput')
    searchInputField;

    @ViewChild('shortcuts')
    shortcutsEl: ElementRef;
    isSearchEnable:boolean=false;

    // Private
    private _unsubscribeAll: Subject<void>;
    processTemplates: any;
    list: { id: number; name: string; }[];
    currentUser: any;
    permissionList = [];
    textsearch: any;
    public selected = false;
    resultArray: any[] = [];
    DateDiff: number;
    currentDate: moment.Moment;
    isDoctor = false;
    hasMedicoId = false;
    shortcutClass = "shortcuts-mobile-toggle";
    newSearchDataSet:any;
    isFirst:boolean=true;

    /**
     * Constructor
     *
     * @param {CookieService} _cookieService
     * @param {FuseMatchMediaService} _fuseMatchMediaService
     * @param {FuseNavigationService} _fuseNavigationService
     * @param {MediaObserver} _mediaObserver
     * @param {Renderer2} _renderer
     */
    constructor(
        private _cookieService: CookieService,
        private _fuseMatchMediaService: FuseMatchMediaService,
        private _fuseNavigationService: FuseNavigationService,
        private _mediaObserver: MediaObserver,
        private _renderer: Renderer2,
        public headerService: HeaderService,
        public employeeService: EmployeeService,
        public employeeStoreService: EmployeeStoreService,
        public router: Router,
        public leaveService: LeaveService,
        public sharedService: SharedService,
        public snackBar: MatSnackBar,
        public dialog: MatDialog,
        public doctorBillingService: DoctorBillingService,
        private dateAdapter: DateAdapter<any>,
        private fileExportService: FileExportService,
        private _sendingService: SendingService,

    ) {
        // Set the defaults
        this.shortcutItems = [];
        this.searching = false;
        this.mobileShortcutsPanelActive = false;

        // Set the private defaults
        this._unsubscribeAll = new Subject();
        this.currentUser = JSON.parse(Utils.decrypt(localStorage.getItem('currentUser'))) ;
        if (this.currentUser) {
            this.permissionList = this.currentUser.permissionIds;
            this.isDoctor = this.currentUser.rolId === 5;
            if (this.currentUser.medicoId !== undefined && this.currentUser.medicoId !== null && this.currentUser.medicoId !== '') {
                this.hasMedicoId = true;
            }
        }

        this.employeeService.selectUserData.subscribe((data: any) => {
            this.router.navigateByUrl('/employee');
            this.selectedOption(data.trabajadorSurname, data);
            this.callTrabajaro();
        });


        this.employeeService.selectUserappointment.subscribe((data: any) => {
            this.router.navigateByUrl('/employee');
            this.selectedOption(data.apellidos, data);
            this.callTrabajaro();
        });

        // this.callTrabajaro(); 
        // This is commented because just after login in there is an api call without any purpose.
    }

    callTrabajaro(): void {
        const Emplooyeeid = localStorage.getItem('EmplooyeeID');
        const BajaId = localStorage.getItem('bajaId');
        if (Emplooyeeid !== 'null') {
            this.employeeService.getTrabajador(Emplooyeeid);
        }
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
       if(localStorage.getItem('currentUser'))
       {
        this.getAllMedicos();

        // Get all administrative users for sendigs drop down
        this.getAdministrativeUsers();

       }
        // Get all medicos for sendigs drop down
        
        // this.searchEmployee()
        // Get the navigation items and flatten them
        this.filteredNavigationItems = this.navigationItems = this._fuseNavigationService.getFlatNavigation(this.navigation);

        if (this._cookieService.check('FUSE2.shortcuts')) {
            this.shortcutItems = JSON.parse(this._cookieService.get('FUSE2.shortcuts'));
        }
        else {
            // User's shortcut items
            this.shortcutItems = [
                {
                    'title': 'Calendar',
                    'type': 'item',
                    'icon': 'today',
                    'url': '/apps/calendar'
                },
                {
                    'title': 'Mail',
                    'type': 'item',
                    'icon': 'email',
                    'url': '/apps/mail'
                },
                {
                    'title': 'Contacts',
                    'type': 'item',
                    'icon': 'account_box',
                    'url': '/apps/contacts'
                },
                {
                    'title': 'To-Do',
                    'type': 'item',
                    'icon': 'check_box',
                    'url': '/apps/todo'
                }
            ];
        }

        moment.locale('es');
        this.dateAdapter.setLocale('es');


        // Subscribe to media changes
        this._fuseMatchMediaService.onMediaChange
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(() => {
                if (this._mediaObserver.isActive('gt-sm')) {
                    if (this.shortcutsEl) {
                        this.hideMobileShortcutsPanel();
                    }
                }
            });

        this.sharedService.setDataForSelectionTabList();

        const user = JSON.parse(Utils.decrypt(localStorage.getItem('currentUser'))) ;
        if (user)
            this.showHomeButton = user.medicoId || user.coordinador;
    }

    OnHomeClick(): void {
        const user: any = JSON.parse(Utils.decrypt(localStorage.getItem('currentUser'))) ;
        if (user.medicoId) {
            this.router.navigate(['/doctor']);
        } else if (user.coordinador) {
            this.router.navigate(['/coordinators-main']);
        } else {
            this.router.navigate(['/admin']);
        }
    }

    OnCompanyClick() {
        this.router.navigate(['/company-view']);
    }

    OnSelectionViewClick(): void {
        if (this.sharedService.selectionTabList.filter(e => e.id === 2 && e.isPermit).length > 0) {
            this.sharedService.selectedSelectionTabId = 2;
        } else {
            this.sharedService.selectedSelectionTabId =
                this.sharedService.selectionTabList.filter(e => e.isPermit).length > 0 ? this.sharedService.selectionTabList.filter(e => e.isPermit)[0].id : 0;
        }
        this.router.navigate(['/selection-view']);
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Search
     *
     * @param event
     */
    search(event): void {
        const value = event.target.value.toLowerCase();

        if (value === '') {
            this.searching = false;
            this.filteredNavigationItems = this.navigationItems;

            return;
        }

        this.searching = true;

        this.filteredNavigationItems = this.navigationItems.filter((navigationItem) => {
            return navigationItem.title.toLowerCase().includes(value);
        });
    }

    /**
     * Toggle shortcut
     *
     * @param event
     * @param itemToToggle
     */
    toggleShortcut(event, itemToToggle): void {

        event.stopPropagation();
        for (let i = 0; i < this.shortcutItems.length; i++) {
            if (this.shortcutItems[i].url === itemToToggle.url) {
                this.shortcutItems.splice(i, 1);

                // Save to the cookies
                this._cookieService.set('FUSE2.shortcuts', JSON.stringify(this.shortcutItems));

                return;
            }
        }

        this.shortcutItems.push(itemToToggle);

        // Save to the cookies
        this._cookieService.set('FUSE2.shortcuts', JSON.stringify(this.shortcutItems));
    }

    /**
     * Is in shortcuts?
     *
     * @param navigationItem
     * @returns {any}
     */
    isInShortcuts(navigationItem): any {
        return this.shortcutItems.find(item => {
            return item.url === navigationItem.url;
        });
    }

    /**
     * On menu open
     */
    onMenuOpen(): void {
        setTimeout(() => {
            this.searchInputField.nativeElement.focus();
        });
    }

    /**
     * Show mobile shortcuts
     */
    showMobileShortcutsPanel(): void {

        this.mobileShortcutsPanelActive = true;
        this._renderer.addClass(this.shortcutsEl.nativeElement, 'show-mobile-panel');
    }

    /**
     * Hide mobile shortcuts
     */
    hideMobileShortcutsPanel(): void {

        this.mobileShortcutsPanelActive = false;
        this._renderer.removeClass(this.shortcutsEl.nativeElement, 'show-mobile-panel');
    }

    searchCommon(value)
    {
            const searchkey = value;
            const EmpressaId = localStorage.getItem('Empresa');
            this.headerService.getSearchData(searchkey, EmpressaId).subscribe(
                (data: any) => {
                    this.options = [];
                    if (data.code === 0) {
                        data.result.forEach( (element) => {
                        try {
                            const firstName=element.nombre.split(',')                           
                            const lastName=firstName[0].split(',')
                            element.apellidos=firstName[0] + " " + lastName[0];
                            
                            var lastIndex = element.nombre.lastIndexOf("-")
                            var s1 = element.nombre.substring(0, lastIndex); 
                            var s2 = element.nombre.substring(lastIndex + 1); 
                            element.nivel1=s2;

                            this.options.push(element)
                        } catch (error) {
                        }
                        });
                        //this.options = data.result;
                    } else if (data.code === 1) {
                        this.options = [];
                    }
                }
            );
        
    }

    searchEmployee(value): void {    
        let isnum = /^\d+$/.test(value); 
        if (value.length > 2) {
            this.searchCommon(value);
        } 
        else if(isnum && (value.length==1 || value.length<4)) {
            this.searchCommon(value);
        }
    }

    modelChanged(searchValue): void {
        if(searchValue!=undefined)
        {
            let isnum = /^\d+$/.test(searchValue); 
            if(searchValue.length> 2)
            {
                this.isSearchEnable=true
            }else if(isnum && (searchValue.length==1 || searchValue.length<4))
            {
                this.isSearchEnable=true
            }else
            {
                this.isSearchEnable=false;
            }
        }
        this.options = [];
    }

    selectedOption(selected, value): void {
        this.isSearchEnable=false;
        this.employeeService.isEmployeeDeleted = false;
        this.textsearch = selected;
        this.headerService.textsearch = selected;
        this.employeeService.currentEmployeeId = value.trabajadorId;
        this.employeeService.currentEmployee = value;
        this.employeeStoreService.employee = value;
        this.employeeService.getemployeeID(value.trabajadorId);
        localStorage.setItem('EmplooyeeID', value.trabajadorId);
        localStorage.setItem('textsearch', this.textsearch);
        localStorage.setItem('EmplooyeeData', JSON.stringify(value));
        this.employeeService.getEmployeeDetails(value.trabajadorId).subscribe(
            res => {
                let response: any;
                response = res;
                let fristdate: any;
                let seconddate: any;
                let formattedToday: any;
                this.resultArray = response.result;
                if (response.result) {
                    for (let i = 0; i < this.resultArray.length; i++) {
                        if (this.resultArray[i].Fbaja !== null) {
                            fristdate = moment(this.resultArray[i].Fbaja.split('T')[0]);
                        }
                        if (this.resultArray[i].Falta !== null) {
                            seconddate = moment(this.resultArray[i].Falta.split('T')[0]);
                            this.DateDiff = moment.duration(seconddate.diff(fristdate)).asDays();
                            this.resultArray[i].Dias = this.DateDiff + 1;
                        } else {
                            formattedToday = moment(new Date());
                            this.DateDiff = moment.duration(formattedToday.diff(fristdate)).asDays();
                            this.resultArray[i].Dias = this.DateDiff + 1;
                        }

                        if (i + 1 === this.resultArray.length) {
                            this.employeeService.bajas = response.result;
                            if (response.result.length > 0) {
                                this.leaveService.SelectedRowId = response.result[0].id;
                            }
                        }
                    }

                    this.employeeStoreService.initEmployee();
                }
            }
        );
        if (value.trabajadorId != -1) {
            this.employeeService.getheaderDetails(value.trabajadorId).subscribe();
            this.employeeService.getTrabajador(value.trabajadorId);

            localStorage.removeItem('LeaveID');
            this.leaveService.SelectedRowId = 0;
        
            if(this.isFirst)
            {
                this.router.navigate(['/employee']);
                this.isFirst=false;
            }else
            { 
                this.redirectTo('/employee');
            }
        }
    }
    redirectTo(uri:string){
        this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=>
        this.router.navigate([uri]));
     }

    OnReportsClick(): void {
        // const user: any = JSON.parse(localStorage.getItem('currentUser'));
        // if (user.medicoId !== undefined && user.medicoId !== null && user.medicoId !== '') {
        //     this.router.navigate(['/reports-view']);
        // }
        // commented above condition - as per the instruction given by Oscar (no need to check medico id) 09/12-2021
        this.router.navigate(['/reports-view']);
    }

    Navigate(): void {
        if (this.sharedService.selectionTabList.filter(e => e.id === 5 && e.isPermit).length > 0) {
            this.sharedService.selectedSelectionTabId = 5;
            this.router.navigate(['/selection-view']);
        } else {
            this.showSnackBar('Permission denied', '', 2500);
        }
    }

    public showSnackBar(message: string, action: string, duration: number): MatSnackBarRef<SimpleSnackBar> {
        return this.snackBar.open(message, action, {
            duration: duration
        });
    }

    //#region "Add new Employee=>PopUp"

    showAddNewEmployeePopup() {
        let dialogData = {};
        const dialogRef = this.dialog.open(CreateNewEmployeeComponent, {
            data: dialogData
        });
        dialogRef.afterClosed().subscribe(response => { });
    }


    //#endregion

    //Region Doctor billing
    confirmTransferActuaciones() {
        const dialogData = new ConfirmDialogModel('¿Traspasar actuaciones con importe a la deuda del médico?', "");
        const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
            data: dialogData
        });

        dialogRef.afterClosed().subscribe(responce => {
            if (responce) {
                const modalRef = this.dialog.open(TransferActuacionesModalComponent, { data: "" });
                modalRef.afterClosed().subscribe(res => {
                });
            }
        });
    }

    confirmTransferOtrosGastos() {
        const dialogData = new ConfirmDialogModel('¿Traspasar los otros gastos a la deuda del médico?', "");
        const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
            data: dialogData
        });

        dialogRef.afterClosed().subscribe(responce => {
            if (responce) {
                this.doctorBillingService.TransferOtrosGastos()
                    .subscribe(res => {
                        if (res.result == 1 && res.code === 0) {
                            this.sharedService.ShowSnackBar('Traspaso realizado correctamente', 'Okay', 2000);
                        } else {
                            this.sharedService.ShowSnackBar('error');
                        }
                    }, err => {
                        this.sharedService.ShowSnackBar('error');
                        console.error(err);
                    });
            }
        });
    }

    confirmCreateBill() {
        this.doctorBillingService.getInitialDates().subscribe(res => {
            if (res.code === 0) {

                this.currentDate = moment().set({ year: res.result.year, month: (res.result.month - 1) });

                const title = "¿Crear las facturas correspondientes al mes de " + this.currentDate.format('MMMM') + " de " + this.currentDate.format('YYYY') + "?";
                const dialogData = new ConfirmDialogModel(title, "");

                const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
                    data: dialogData
                });

                dialogRef.afterClosed().subscribe(responce => {
                    if (responce) {
                        this.doctorBillingService.CreateBill()
                            .subscribe(res => {
                                if (res.result == 1 && res.code === 0) {
                                    this.sharedService.ShowSnackBar('Traspaso realizado correctamente', 'Okay', 2000);
                                } else {
                                    this.sharedService.ShowSnackBar('Fallar la transferencia');
                                }
                            }, err => {
                                this.sharedService.ShowSnackBar('Fallar la transferencia');
                                console.error(err);
                            });
                    }
                });
            } else {
                this.sharedService.ShowSnackBar('No se pudo cargar la fecha inicial', 'Okay', 2000);
            }
        }, error => {
            this.sharedService.ShowSnackBar('No se pudo cargar la fecha inicial', 'Okay', 2000);
            console.error(error);
        });
    }

    confirmClosingBillingPeriod() {
        const modalRef = this.dialog.open(CerrarfacturacionModalComponent, { data: "" });
        modalRef.afterClosed().subscribe(res => {
        });
    }

    confirmImprimirDeuda() {

        const dialogData = new ConfirmDialogModel("¿Imprimir deuda?", "");
        const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
            data: dialogData
        });

        dialogRef.afterClosed().subscribe(responce => {
            if (responce) {
                this.doctorBillingService.GenerateReportForAll()
                    .subscribe(res => {
                        if (res.result != null && res.code === 0) {
                            this.fileExportService.DownloadFile(res.result.file, res.result.fileName);
                            this.sharedService.ShowSnackBar('Imprimir deuda con éxito', 'Okay', 2000);
                        } else {
                            this.sharedService.ShowSnackBar('imprimir deuda fallar');
                        }
                    }, err => {
                        this.sharedService.ShowSnackBar('imprimir deuda fallar');
                        console.error(err);
                    });
            }
        });
    }

    //End Region Doctor billing


    toggleBar() {

        if (this.shortcutClass === "shortcuts-mobile-toggle")
            this.shortcutClass += " mobile-expand";
        else
            this.shortcutClass = "shortcuts-mobile-toggle";

    }

    //#region Sendings Menu
    public openTaskPopup(): void {
        const dialogRef = this.dialog.open(TaskPopupComponent, {
            data: { medicos: this.allDoctors, admintrativeUsers: this.allAdministrativeUsers }
        });
        dialogRef.afterClosed().subscribe(res => {
            // Whatever to do after closing, remove if not needed
        });
    }

    public openTaskEliminationPopup(): void {
        const dialogRef = this.dialog.open(TaskEliminationPopupComponent, {
            data: { medicos: this.allDoctors, admintrativeUsers: this.allAdministrativeUsers }
        });
        dialogRef.afterClosed().subscribe(res => {
            // Whatever to do after closing, remove if not needed
        });
    }

    public OpenDerivarAMutuaPopup(): void {
        const dialogRef = this.dialog.open(DerivarMutuaComponent, {
        });
        dialogRef.afterClosed().subscribe(res => {
            // Whatever to do after closing, remove if not needed
        });
    }

    public openDischargesPopupPopup(): void {
        const dialogRef = this.dialog.open(DischargesPopupComponent, {
            data: { medicos: this.allDoctors, admintrativeUsers: this.allAdministrativeUsers }
        });
        dialogRef.afterClosed().subscribe(res => {
            // Whatever to do after closing, remove if not needed
        });
    }

    public openReportsPopup(): void {
        const dialogRef = this.dialog.open(ReportsPopupComponent, {
            data: { admintrativeUsers: this.allAdministrativeUsers }
        });
        dialogRef.afterClosed().subscribe(res => {
            // Whatever to do after closing, remove if not needed
        });
    }

    private getAllMedicos(): void {
        this._sendingService.getAllMedicos().subscribe(res => {
            if (res.code === 0) {
                this.allDoctors = res.result;
            }
        });
    }

    private getAdministrativeUsers(): void {
        this._sendingService.administrativeUsers().subscribe(res => {
            if (res.code === 0) {
                this.allAdministrativeUsers = res.result;
            }
        });
    }

    public openDischargeRequestPopup(): void {
        const dialogRef = this.dialog.open(OpenDischargeRequestPopupComponent, {
            data: { admintrativeUsers: this.allAdministrativeUsers }
        });
        dialogRef.afterClosed().subscribe(res => {
            // Whatever to do after closing, remove if not needed
        });
    }

    public openAddressRequestPopup(): void {
        const dialogRef = this.dialog.open(OpenAddressRequestPopupComponent, {
            data: { admintrativeUsers: this.allAdministrativeUsers }
        });
        dialogRef.afterClosed().subscribe(res => {
            // Whatever to do after closing, remove if not needed
        });
    }

    public openStaffRequestPopup(): void {
        const dialogRef = this.dialog.open(OpenStaffRequestPopupComponent, {
            data: { admintrativeUsers: this.allAdministrativeUsers }
        });
        dialogRef.afterClosed().subscribe(res => {
            // Whatever to do after closing, remove if not needed
        });
    }

    public sendCitationPopup(): void {
        const dialogRef = this.dialog.open(SendCitationsComponent, {
            data: { admintrativeUsers: this.allAdministrativeUsers }
        });
        dialogRef.afterClosed().subscribe(res => {
            // Whatever to do after closing, remove if not needed
        });
    }

    private GetEmpresaValueFromHeader(): string {
        if (this._sendingService.selectedCompanyId == null) {
            return localStorage.getItem('Empresa');
        } else {
            return this._sendingService.selectedCompanyId;
        }
    }


    /**
     * Open data cancellation popup
     */
    public DatacancelPopup(): void {
        this.dialog.open(DataCancelComponent);
    }

}
